"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentClass = exports.outerClass = void 0;
const nano_theme_1 = require("nano-theme");
exports.outerClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    d: 'flex',
    jc: 'center',
    w: '100%',
    maxW: '100%',
    minW: 0,
    bxz: 'border-box',
});
exports.contentClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    maxW: '100%',
    minW: 0,
    bxz: 'border-box',
});
